class IndustriesByCompany {
	async getAllIndustries() {
		const response = await fetch(`${process.env.REACT_APP_API}/industry`, {
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async getCompanies(industryId, subIndustryId, page, records) {
		const response = await fetch(
			`${process.env.REACT_APP_API}/industry/companies?industryId=${industryId}&subIndustryId=${subIndustryId}&page=${page}`,
			{
				headers: {
					'Content-type': 'application/json',
				},
			}
		)

		return response.json()
	}

	async getByIds(ids) {
		const response = await fetch(`${process.env.REACT_APP_API}/byIds?ids=${ids}`, {
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}
}

export default new IndustriesByCompany()
